<template>
  <div>
    <el-container :style="screenHeight">
      <el-header>
        <label class="flow-title" :title="flowName">{{flowName}}</label>
        <ul class="header">
          <!--节点-->
          <li
            v-for="(item,index) in nodeData"
            :key="index"
            :data-shape="item.shape"
            :data-color="item.color"
            :data-size="item.size"
            draggable
            class="nodeClass"
            @dragstart="handleDragstart"
            @dragend="handleDragEnd($event,item)"
          >
            <div class="nodeDiv">
              <img :src="item.icon" class="top-icon"/>
              <label style="margin-left: 3px;line-height: 23px;" :title="item.label">{{item.label}}</label>
            </div>
          </li>
          <!--end nodes-->
          <!--<li>
            <Tooltip placement="top" content="复制" theme="light">
              <i class="el-icon-document-copy" @click="handleCopy"></i>
            </Tooltip>
          </li>
          <li>
            <Tooltip placement="top" content="粘贴" theme="light">
              <i class="el-icon-document-checked" @click="handlePaste"></i>
            </Tooltip>
          </li>-->
          <!--<li>
            <Tooltip placement="top" content="测试用" theme="light">
              <i class="el-icon-document-checked" @click="getData"></i>
            </Tooltip>
          </li>-->
          <li>
            <Tooltip placement="top" content="删除" theme="light">
              <i class="el-icon-delete" @click="handleDelete"></i>
            </Tooltip>
          </li>
          <li>
            <Tooltip placement="top" content="清空画布" theme="light">
              <i class="el-icon-delete-solid" @click="handleClear"></i>
            </Tooltip>
          </li>
          <!--<li>
            <Tooltip placement="top" content="撤销" theme="light">
              <Icon type="ios-undo" @click="handleUndo" :style="undoClass"></Icon>
            </Tooltip>
          </li>
          <li>
            <Tooltip placement="top" content="重做" theme="light">
              <Icon type="ios-redo" @click="handleRedo" :style="redoClass"></Icon>
            </Tooltip>
          </li>-->
          <li>
            <Tooltip placement="top" content="放大" theme="light">
              <i class="el-icon-zoom-in" @click="handleZoomIn"></i>
            </Tooltip>
          </li>
          <li>
            <Tooltip placement="top" content="缩小" theme="light">
              <i class="el-icon-zoom-out" @click="handleZoomOut"></i>
            </Tooltip>
          </li>
          <li>
            <Tooltip placement="top" content="重置" theme="light">
              <Icon type="ios-sync" @click="handleResetZoom"></Icon>
            </Tooltip>
          </li>

          <li style="padding-left: 20px;">
            <Tooltip placement="top" content="保存" theme="light">
              <i class="el-icon-success" @click="saveFlow"/>
            </Tooltip>
          </li>
          <!--<li>
            <Tooltip placement="top" content="测试" theme="light">
              <Icon type="ios-hammer" @click="testFlow"/>
            </Tooltip>
          </li>-->
          <li>
            <Tooltip placement="top" content="发布" theme="light">
              <Icon type="md-cloud-upload" @click="publishOrDown('publish')" v-show="roleList['a_2-9']"/>
            </Tooltip>
          </li>
          <li>
            <Tooltip placement="top" content="下线" theme="light">
              <Icon type="md-cloud-download" @click="publishOrDown('down')" v-show="roleList['a_2-9']"/>
            </Tooltip>
          </li>

        </ul>
        <el-select
          v-model="nodeName"
          placeholder="请选择节点"
          clearable
          filterable
          size="small"
          @change="changeNodeStation"
          style="float: right;max-width: 150px;margin-right: 15px;">
          <el-option
            v-for="item in nodes"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-header>
      <el-container>
        <el-aside width="50px">
          <ul style="margin-top: 30px">
            <li>
              <Tooltip placement="right" content="意图列表" theme="light">
                <!--<i class="el-icon-aim" @click="indentDrawer=true"></i>-->
                <img :src="indentImg" @click="indentDrawer=true" class="left-icon"/>
              </Tooltip>
            </li>
            <li>
              <Tooltip placement="right" content="名词列表" theme="light">
                <!--<i class="el-icon-notebook-1" @click="nounDrawer=true"></i>-->
                <img :src="nounImg" @click="nounDrawer=true" class="left-icon"/>
              </Tooltip>
            </li>
            <li>
              <Tooltip placement="right" content="全局变量" theme="light">
                <!--<i class="el-icon-star-off" @click="showGlobalDialog"></i>-->
                <img :src="variablesImg" @click="showGlobalDialog" class="left-icon"/>
              </Tooltip>
            </li>
            <!--语音文件-->
            <li>
              <Tooltip placement="right" content="语音文件" theme="light">
                <!--<i class="el-icon-folder" @click="fileDrawer=true"></i>-->
                <img :src="recordFilesImg" @click="fileDrawer=true" class="left-icon"/>
              </Tooltip>
            </li>
            <!--<li>
              <Tooltip placement="right" content="调试窗" theme="light">
                &lt;!&ndash;<i class="el-icon-s-tools" @click="testDrawer=true"></i>&ndash;&gt;
                <img :src="dialogImg" @click="testDrawer=true" class="left-icon"/>
              </Tooltip>
            </li>-->
          </ul>
        </el-aside>
        <el-main>
          <!--图的画布容器-->
          <div :id="containerId" style="background-color: white;position: relative" class="graphic-container">
          </div>
          <div :id="navId" class="win">
          </div>
        </el-main>
      </el-container>
      <!--<el-footer>
        Footer
      </el-footer>-->
    </el-container>

    <!--全局变量弹窗-->
    <el-dialog title="全局变量编辑" :visible.sync="globalVariableVisible" width="500px">
      <el-form label-width="80px" inline>
        <el-form-item label="全局变量:">
          <div>
            <template v-for="(variable,index) in globalVariables">
              <div :key="index">
                <el-input v-model="variable.vName" :key="index" style="width: 280px;margin-right: 5px;margin-bottom: 5px;"></el-input>
                <i class="el-icon-delete" style="cursor: pointer" @click.prevent="deleteGlobalVariable(variable)"></i>
              </div>
            </template>
            <a @click="addGlobalVariable">+新增全局变量</a>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveGlobalVariable">确定</el-button>
        <el-button @click="globalVariableVisible=false">取消</el-button>
      </div>
    </el-dialog>

    <!--意图抽屉-->
    <IndentDrawer :indent="indentDrawer" :flowId="flowId" @closeDrawer="closeDrawer"></IndentDrawer>
    <!--名词抽屉-->
    <NonuDrawer :noun="nounDrawer" :flowId="flowId" @closeDrawer="closeDrawer"></NonuDrawer>
    <!--语音文件抽屉-->
    <FileDrawer :file="fileDrawer" :flowId="flowId" @closeDrawer="closeDrawer"></FileDrawer>
    <!--测试抽屉--><!--待开发-->
    <!--<TestDrawer :test="testDrawer" :flowId="flowId" @closeDrawer="closeDrawer"></TestDrawer>-->
    <!--右侧节点属性抽屉-->
    <NodeDrawer
      :nodeShow="nodeDrawer"
      :flowId="flowId"
      :model="nodeModel"
      :nodeList="nodes"
      @closeNodeDrawer="closeNodeDrawer"
      @updateData="receivedData"
      @updateNodeLabel="updateNode"
      @deleteRecognize="deleteRecognize"
      @deleteJudge="deleteJudge"
      @updateRecognizeLabel="updateRecognize"
      @updateJudgeLabel="updateJudgeLabel"
    ></NodeDrawer>
    <Base/>
  </div>
</template>

<script>
  import G6 from '@antv/g6'
  import {publicFunClass} from "@/components/js/PublicFunClass.js"
  import {initBehaviors} from '@/components//flow/components/behavior/index.js'
  import IndentDrawer from "./components/IndentDrawer";
  import NonuDrawer from "./components/NonuDrawer";
  import TestDrawer from "./components/TestDrawer";
  import {uniqueId} from '@/util'
  import NodeDrawer from "./components/NodeDrawer";
  import Base from "./components/Base/index";
  import eventBus from "../../util/eventBus";
  import FileDrawer from "./components/FileDrawer";

  //imgs
  import indent from '@/assets/image/indent.png'
  import noun from '@/assets/image/noun.png'
  import recordFiles from '@/assets/image/recordFiles.png'
  import variables from '@/assets/image/variables.png'
  import dialog from '@/assets/image/dialog.png'
  //node img
  import startNodeImg from '@/assets/image/start_node.png'
  import voiceNodeImg from '@/assets/image/voice_node.png'
  import dtmfNodeImg from '@/assets/image/dtmf_node.png'
  import httpNodeImg from '@/assets/image/http_node.png'
  import endNodeImg from '@/assets/image/end_node.png'

  export default {
    name: "workspace",
    components: {FileDrawer, Base, NodeDrawer, TestDrawer, NonuDrawer, IndentDrawer},
    mixins: [publicFunClass],
    props: {
      pageCode: String
    },
    data() {
      return {
        indentImg:indent,
        nounImg:noun,
        variablesImg:variables,
        recordFilesImg:recordFiles,
        dialogImg:dialog,
        roleList: JSON.parse(localStorage.getItem('roleList')),
        flowName: 'AI流程',
        flowId: '',
        screenHeight: {height: ''},
        drawerStyle: {height: 623, width: 1278},
        globalVariableVisible: false,
        globalVariables: [],
        deleteGlobalVariables: [],
        indentDrawer: false,
        nounDrawer: false,
        testDrawer: false,
        nodeDrawer: false,
        fileDrawer: false,
        nodes: [],
        nodeName: '',
        containerId: 'mountNode',
        navId: 'win',
        miniMap: null,
        grid: null,
        graph: null,
        Util: null,
        nodeModel: null,
        selectItem: null,//选中的item(node or edge)
        lastItem: null,
        copyItem: null,
        redoList: [],//重做
        undoList: [],//撤销
        redoClass:{color:'gray'},
        undoClass:{color:'gray'},
        nodeData: [
          {
            name: '开始节点',
            icon: startNodeImg,
            label: '开始节点',
            type: 'customNode',
            color: '#000',
            //inPoints: [[0, 0.5]],
            outPoints: [[1, 0.5]],
            size: '100*35',
            nodeData:null,
            x: 0,
            y: 0,
          },
          {
            name: '语音节点',
            icon: voiceNodeImg,
            label: '语音节点',
            type: 'customNode',
            color: '#00BFFF',
            inPoints: [[0, 0.5]],
            outPoints: [[1, 0.5]],
            size: '100*35',
            nodeData:null,
            x: 0,
            y: 0,
          },
          {
            name: 'DTMF节点',
            icon: dtmfNodeImg,
            label: 'DTMF节点',
            type: 'customNode',
            color: '#FF6A6A',
            inPoints: [[0, 0.5]],
            outPoints: [[1, 0.5]],
            size: '100*35',
            nodeData:null,
            x: 0,
            y: 0,
          },
          {
            name: 'HTTP节点',
            icon: httpNodeImg,
            label: 'HTTP节点',
            type: 'customNode',
            color: '#8B8682',
            inPoints: [[0, 0.5]],
            outPoints: [[1, 0.5]],
            size: '100*35',
            nodeData:null,
            x: 0,
            y: 0,
          },
          {
            name: '结束节点',
            icon: endNodeImg,
            label: '结束节点',
            type: 'customNode',
            color: '#8DB6CD',
            inPoints: [[0, 0.5]],
            //outPoints: [[1, 0.5]],
            size: '100*35',
            nodeData:null,
            x: 0,
            y: 0,
          }
        ],
        data: {
          // 点集
          nodes: [],
          // 边集
          edges: []
        },
        offsetX: 0,
        offsetY: 0,
        initNode:null,
        deleteEdges:[],
        deleteNodes:[],
      }
    },
    methods: {
      resetData() {
        this.deleteEdges = []
        this.deleteNodes = []
        this.data = {
          nodes: [],
          edges: []
        }
        this.globalVariables = []
        this.deleteGlobalVariables = []
        this.indentDrawer = false
        this.nounDrawer = false
        this.testDrawer = false
        this.nodeDrawer = false
        this.nodes = []
        this.nodeName = ''
        this.nodeModel = null
        this.selectItem = null//选中的item(node or edge)
        this.lastItem = null
        this.copyItem = null
        this.redoList = []//重做
        this.undoList = []//撤销
      },
      getData() {
        let data = this.graph.save()
        console.log("data",data)
      },
      initData(flowId) {
        let self = this
        let param = {rwId: flowId, flowId: flowId}
        this.$http.post("/AI/FlowDetail/queryNodesAndEdges", param).then(res => {
          let response = res.data
          if (response.flag != '666') {
            that.$alert(response.msg,'提示',{
              confirmButtonText: '确定'
            })
            return false
          }
          let nodes = response.obj.nodes
          let edges = response.obj.edges
          if (Array.isArray(nodes) && nodes.length > 0) {
            nodes.forEach(async node => {
              let type = node.type + ''
              if (type === '1') {
                node.color = '#000'
                node.name = '开始节点'
                node.icon = startNodeImg
              } else if (type === '2') {
                node.color = '#00BFFF'
                node.name = '语音节点'
                node.icon = voiceNodeImg
              } else if (type === '3') {
                node.color = '#FF6A6A'
                node.name = 'DTMF节点'
                node.icon = dtmfNodeImg
              } else if (type === '4') {
                node.color = '#8B8682'
                node.name = 'HTTP节点'
                node.icon = httpNodeImg
              } else if (type === '5') {
                node.color = '#8DB6CD'
                node.name = '结束节点'
                node.icon = endNodeImg
              }
              node.type = 'customNode';
              //node.size = '100*35'
              node.nodeData = null
              node.x = parseFloat(node.x)
              node.y = parseFloat(node.y)
              if (type !== '5') {
                node.outPoints = [[1, 0.5]];
              }
              if (type !== '1') {
                node.inPoints = [[0, 0.5]]
              }
              let data = await self.initNodeData(node.nodeId, '');
              data.deleteOrs = []
              data.deleteActions = []
              data.deleteRecognizes = []
              data.deleteOrs = []
              data.deleteAnds = []
              data.deleteBranches = []
              data.deleteHeaders = []
              data.deleteQueries = []
              node.nodeData = data
            })
          }
          if (Array.isArray(edges) && edges.length > 0) {
            edges.forEach(edge => {
              edge.tempId = edge.id
              edge.id = 'edge'+edge.id
              edge.type = 'customEdge'
              edge.target = edge.targetId + ''
              edge.source = edge.sourceId + ''
            })
          }
          this.data.nodes = nodes
          this.data.edges = edges
          if (self.graph) {
            self.graph.data(this.data);
            self.graph.render()
          }
        })
      },
      receivedData(data) {
        //更新节点数据
        let id = data.scene.id
        if (id) {
          let model = {
            nodeData:data
          }
          if (this.graph) {
            if (this.nodeDrawer) {
              if (this.lastItem) {
                //更新上次的
                this.graph.update(this.lastItem,model);
              }
            } else {
              if (this.selectItem) {
                //
                this.graph.update(this.selectItem, model)
                this.selectItem = null
              }
            }
          }

        }
      },
      initNodesData(flowId) {
        let param = {rwId: flowId}
        this.$http.post('/AI/nodes', param).then(res => {
          let response = res.data
          if (response.flag !== '666') {
            console.log("load nodes data error", response.msg)
            return
          }
          this.nodes = []
          this.nodes = response.obj
        });
      },
      initNodeData(sceneId,indentId) {
        let that = this
        return new Promise((resolve, reject) => {
          let param = {type:'0',sceneId:sceneId,indentId:indentId,rwId:this.flowId}
          that.$http.post('/AI/node/detail',param).then(res=>{
            let response = res.data
            if (response.flag !== '666') {
              console.log('load node detail data error',response.msg)
              that.$message.error('加载节点数据出错')
              resolve(null)
            }
            resolve(response.obj)
          })
        })
      },
      generatorInitNodeData(model) {
        let nodeData = {}
        let scene = {rsInterrupt: 0,id:model.id,rsType:'1',rsName:model.label,rwId:this.flowId,isFirstNode:'0',rsOverTime:30,rsFocus:''}
        if (model.name === '开始节点') {
          scene.isFirstNode = '1'
          scene.rsType = '1'
          nodeData.actions = []
          nodeData.recognizes = []
          nodeData.params = []
        }else if (model.name === '语音节点') {
          scene.rsType = '1'
          nodeData.actions = []
          nodeData.recognizes = []
          nodeData.params = []
        }else if (model.name === 'DTMF节点') {
          scene.rsType = '2'
          nodeData.actions = []
          nodeData.dtmf = {
            id:'',
            rsId:'',
            respVId:'',
            respVName:'',
            length:'',
            terminator:'#',
            othersNextSceneId:''
          }
          nodeData.judges = []
        }else if (model.name === 'HTTP节点') {
          scene.rsType = '3'
          nodeData.http = {id:'',method:'',url:'',othersNextSceneId:'',received:'',receivedName:'',headers:[],bodies:[{id:'',rsId:'',body:''}],queries:[]}
          nodeData.judges = []
        }else if (model.name === '结束节点') {
          scene.rsType = '4'
          nodeData.actions = []
          nodeData.endActions=[]
        }
        nodeData.scene = scene
        //删除数据集合
        nodeData.deleteActions = []
        nodeData.deleteRecognizes = []
        nodeData.deleteOrs = []
        nodeData.deleteAnds = []
        nodeData.deleteBranches = []
        nodeData.deleteHeaders = []
        nodeData.deleteQueries = []
        return nodeData
      },

      generatorInitEdgeData(model, type) {
        let json = {}
        let sourceModel = this.graph.findById(model.sourceId).getModel()
        let targetModel = this.graph.findById(model.targetId).getModel()
        let sourceId = ''
        let targetId = ''
        if (sourceModel) {
          sourceId = sourceModel.nodeId
        }
        if (targetModel){
          targetId = targetModel.nodeId
        }
        if (type === 1) {
          json.id = ''
          json.rsId = sourceId
          json.trigger = 1
          json.symbol = '=='
          json.purposeId = ''
          json.nextSceneId = targetId
          //添加线ID
          json.edgeId = model.id
        }else if (type === 2 || type === 3) {
          //branches
          json.id = ''
          json.nextSceneId = targetId
          json.rsId = sourceId
          json.name = model.label
          json.edgeId = model.id
          json.or = [
            {
              id:'',
              branchId:'',
              ands:[]
            }
          ]
        }
        return json
      },
      initGlobalVariables(flowId) {
        let param = {rwId: flowId}
        this.$http.post('/AI/FlowDetail/queryGlobalVariables', param).then(res => {
          let response = res.data
          if (response.flag !== '666') {
            console.log('load globalvariables error', response.msg)
            return
          }
          this.globalVariables = response.obj
        })
      },
      showGlobalDialog() {
        this.initGlobalVariables(this.flowId)
        this.globalVariableVisible = true
      },
      saveGlobalVariable() {
        let that = this
        //先保存
        let param = {
          rwId: this.flowId,
          deleteGlobalVariables: JSON.stringify(this.deleteGlobalVariables),
          data: JSON.stringify(this.globalVariables),
          menuId:'a_2-8',
          journalType:'AI机器人管理=>AI流程配置=>绘制流程=>全局变量',
        }
        this.$http.post('/AI/FlowDetail/saveGlobalVariables', param).then(res => {
          let response = res.data
          if (response.flag !== '666') {
            that.$Modal.info({
              title: '提示',
              content: res.data.msg
            });
          } else {
            that.$Message.info('保存全局变量成功！');
            that.globalVariableVisible = false
          }
        })
      },
      addGlobalVariable() {
        this.globalVariables.push({
          id: '',
          rwId: this.flowId,
          vName: '',
          descr: '',
          key: Date.now()
        })
      },
      saveFlow() {
        let data = this.graph.save()
        let edgeArr = []
        let nodeArr = []
        if (data) {
          let edges = data.edges
          let nodes = data.nodes
          if (nodes.length <= 0) {
            this.$Message.info('流程数据为空')
          }
          if (edges.length > 0) {
            edges.forEach(edge=>{
              let json = {}
              json.targetId = edge.targetId
              json.sourceId = edge.sourceId
              json.label = edge.label
              if (edge.tempId) {
                json.id = edge.tempId;
              } else {
                json.id = ''
              }
              json.flowId = this.flowId
              edgeArr.push(json)
            });
          }
          if (nodes.length > 0) {
            nodes.forEach(node=>{
              let json = {}
              json.id = node.id
              json.nodeId = node.nodeData.scene.id
              json.flowId = this.flowId
              json.label = node.label
              json.x = node.x
              json.y = node.y
              if (node.name === '开始节点') {
                json.type = '1'
              }else if (node.name === 'DTMF节点') {
                json.type = '3'
              }else if (node.name === 'HTTP节点') {
                json.type = '4'
              }else if (node.name === '结束节点') {
                json.type = '5'
              }else if (node.name === '语音节点') {
                json.type = '2'
              }
              json.nodeData = JSON.stringify(node.nodeData);
              nodeArr.push(json)
            })
          }
          let param = {
            rwId:this.flowId,
            nodes:JSON.stringify(nodeArr),
            edges:JSON.stringify(edgeArr),
            deleteNodes:JSON.stringify(this.deleteNodes),
            deleteEdges:JSON.stringify(this.deleteEdges),
            menuId:'a_2-8',
            journalType:'AI机器人管理=>AI流程配置=>保存流程',
          }
          this.$http.post('/AI/node/save',param).then(res=>{
            let response = res.data
            if (response.flag !== '666') {
              this.$Message.error(response.msg);
              console.log('save flow data error',response.msg)
              return
            }
            this.$Message.success('保存成功！');
            this.resetData()
            this.initData(this.flowId)
            this.initNodesData(this.flowId)
          })
        }
      },
      publishOrDown(state) {
        let msg = "是否发布？"
        let successMsg = "发布成功！"
        let param = {flowId:this.flowId,type:'PUBLISH'}
        if (state === 'down') {
          param.type = 'DOWN'
          msg = "是否下线流程：" + this.flowName + "？";
          param.menuId = 'a_2-9'
          param.journalType = 'AI机器人管理=>AI流程管理=>流程下线'
          successMsg = "下线成功！";
        }else if (state === 'publish') {
          param.type = 'PUBLISH';
          msg = "是否发布流程：" + this.flowName + "？";
          param.menuId = 'a_2-9';
          param.journalType = 'AI机器人管理=>AI流程管理=>流程发布';
          successMsg = "发布成功！";
        } else {
          return
        }
        let that = this;
        this.$Modal.confirm({
          title:'提示',
          content:msg,
          onOk:()=>{
            that.$http.post('/AI/WorkFlow/publishOrDown',param).then(res=>{
              let response = res.data
              if (response.flag != '666') {
                that.$alert(response.msg,'提示',{
                  confirmButtonText: '确定'
                })
                return false
              }
              that.$Message.success(successMsg)
              that.initSearch()
            })
          }
        })
      },
      testFlow() {

      },
      deleteGlobalVariable(item) {
        let index = this.globalVariables.indexOf(item)
        let that = this
        if (item.id) {
          //存在ID 。调用接口判断是否在使用中
          let param = {id: item.id, rwId: this.flowId}
          this.$http.post('/AI/FlowDetail/queryUseGlobalVariable', param).then(res => {
            let response = res.data
            if (response.flag != '666') {
              that.$alert(response.msg,'提示',{
                confirmButtonText: '确定'
              })
              return false
            }
            if (response.obj) {
              if (response.obj.length > 0) {
                this.$message.info('节点：[' + response.obj + ']正在使用改变量，请先解除使用！');
                return;
              }
            }
            if (index !== -1) {
              this.globalVariables.splice(index, 1);
              this.deleteGlobalVariables.push(item.id + '')
            }
          })
        }
      },
      closeDrawer(val) {
        this.indentDrawer = false
        this.nounDrawer = false
        this.testDrawer = false
        this.fileDrawer = false
      },
      closeNodeDrawer(val) {
        this.nodeDrawer = false
      },
      changeNodeStation(value) {
        let node = this.graph.findById(value+'')
        if (node) {
          this.graph.focusItem(node)
          //this.graph.moveTo(-80,80)
        }
      },
      getFormatPadding() {
        return this.Util.formatPadding(this.graph.get('fitViewPadding'))
      },
      getViewCenter() {
        const padding = this.getFormatPadding()
        const width = this.graph.get('width')
        const height = this.graph.get('height')
        return {
          x: (width - padding[2] - padding[3]) / 2 + padding[3],
          y: (height - padding[0] - padding[2]) / 2 + padding[0]
        }
      },
      handleZoomIn() {
        const currentZoom = this.graph.getZoom()
        this.graph.zoomTo(currentZoom + 0.1, this.getViewCenter())
      },
      handleZoomOut() {
        const currentZoom = this.graph.getZoom()
        this.graph.zoomTo(currentZoom - 0.1, this.getViewCenter())
      },
      handleResetZoom() {
        this.graph.zoomTo(1, this.getViewCenter())
        this.graph.fitCenter()
      },
      handleDragstart(e) {
        this.offsetX = e.offsetX
        this.offsetY = e.offsetY
      },
      handleDragEnd(e, item) {
        let data = {}
        Object.assign(data, item)
        data.offsetX = this.offsetX
        data.offsetY = this.offsetY
        const graph = this.graph
        const xy = graph.getPointByClient(e.x, e.y)
        data.x = xy.x
        data.y = xy.y
        data.size = item.size.split('*')
        data.id = data.type + uniqueId()
        this.addNodeOrEdge('node', data, true)
      },
      addNodeOrEdge(type, item, pushUndo) {
        let list = []
        if (type === 'node') {
          item.label = item.label + uniqueId()
          if (item.name === '开始节点') {
            let node = this.graph.find('node', node => {
              return node.get('model').name === '开始节点'
            });
            if (node) {
              this.$message.warning("每个流程只能有一个开始节点");
              return
            }
          }
          if (!item.nodeData) {
            item.nodeData = this.generatorInitNodeData(item);
          }
          //
          let mtype = "1"
          if (item.name === '开始节点') {
            mtype = '1'
          }else if (item.name === '语音节点') {
            mtype = '1'
          }else if (item.name === 'DTMF节点') {
            mtype = '2'
          }else if (item.name === 'HTTP节点') {
            mtype = '3'
          }else if (item.name === '结束节点') {
            mtype = '4'
          }
          item.nodeId = item.id
          let json = {name:item.label,id:item.id, type: mtype,nodeId:item.nodeId}
          this.nodes.push(json)
        }
        if (type === 'edge') {
          let edge = this.graph.find('edge',edge=>{
            return edge.get('model').targetId === item.targetId && edge.get('model').sourceId === item.sourceId
          })
          if (edge) {
            this.$message.warning('数据已存在')
            return;
          }
        }
        this.graph.add(type, item);
        if (type === 'edge') {
          this.addEdgeData(item)
        }
        list.push(item);
        //添加边,需要添加数据
        let key = 'add';
        //入栈
        if (pushUndo) {
          this.undoList.push({key, data: list});
        }
        //节点添加结束需要更新搜索下拉框的数据
      },
      addEdgeData(item){
        //新添的全是空
        let sourceId = item.sourceId
        let targetId = item.targetId
        let node = this.graph.findById(sourceId)
        let sourceModel = node.getModel()
        if (sourceModel) {
          let name = sourceModel.name
          let json = {}
          let nodeData = sourceModel.nodeData
          if (name === '开始节点' || name === '语音节点') {
            json = this.generatorInitEdgeData(item,1)
            //生成一个识别数据,加线条ID
            //无论打开与否
            //更新当前添加节点得识别部分的数据
            nodeData.recognizes.push(json)
            let model = {
              nodeData:nodeData
            }
            this.graph.update(node,model)
            this.$message.info('请完善节点识别意图')
            if (this.nodeDrawer) {
              if (this.nodeModel.id === sourceId) {
                eventBus.$emit('addRecognize',json);
              }
            }
          }else if (name === 'DTMF节点' || name === 'HTTP节点') {
            json = this.generatorInitEdgeData(item,2)
            nodeData.judges.push(json)
            let model = {
              nodeData:nodeData
            }
            this.graph.update(node,model)
            this.$message.info('请完善条件判断')
            if (this.nodeDrawer) {
              if (this.nodeModel.id === sourceId) {
                eventBus.$emit('addJudgeBranch',json)
              }
            }
          }

        }
      },
      deleteRecognize(recognize) {
        let edgeId = recognize.edgeId
        let edge = null
        if (edgeId) {
          edge = this.graph.findById(edgeId);
        } else {
          edge = this.graph.find('edge',edge=>{
            return edge.get('model').targetId === recognize.nextSceneId && edge.get('model').sourceId === recognize.rsId
          })
          /*if (edge.length > 0) {
            edge = edge[0]
          }*/
        }
        this.deleteItem(edge)
      },
      updateRecognize(recognize, indent) {
        let edgeId = recognize.edgeId
        let edge = null
        if (edgeId) {
          edge = this.graph.findById(edgeId);
        } else {
          edge = this.graph.find('edge',edge=>{
            return edge.get('model').targetId === recognize.nextSceneId && edge.get('model').sourceId === recognize.rsId
          })
        }
        if (edge) {
          let model = {
            label: indent.name
          }
          this.graph.update(edge,model)
        }
      },
      deleteJudge(judge) {
        let judgeId = judge.edgeId
        let edge = null
        if (judgeId) {
          edge = this.graph.findById(judgeId);
        } else {
          edge = this.graph.find('edge',edge=>{
            return edge.get('model').targetId === judge.nextSceneId && edge.get('model').sourceId === judge.rsId
          })
        }
        if (edge) {
          this.deleteItem(edge)
        }
      },
      updateJudgeLabel(judge) {
        let edgeId = judge.edgeId
        let edge = null
        if (edgeId) {
          edge = this.graph.findById(edgeId);
        } else {
          edge = this.graph.find('edge',edge=>{
            return edge.get('model').targetId === judge.nextSceneId && edge.get('model').sourceId === judge.rsId
          })
        }
        if (edge) {
          let model = {
            label: judge.name
          }
          this.graph.update(edge,model)
        }
      },
      updateNode(id,value) {
        const model = {
          label: value
        }
        this.graph.update(this.selectItem, model)
        this.nodes.forEach(node=>{
          if (node.id === id) {
            node.name = value
          }
        })
      },
      handleDelete() {
        let item = this.selectItem
        if (item) {
          this.deleteItem(item);
        }
        this.selectItem = null
      },
      handleClear() {
        let self = this
        this.$Modal.confirm({
          title:'提示',
          content:'清空画布不能撤销，是否确认清空画布？',
          onOk:()=>{
            self.clearData()
          }
        })
      },
      clearData() {
        this.nodeDrawer = false
        this.nodes = []
        this.nodeName = ''
        this.nodeModel = null
        this.selectItem = null//选中的item(node or edge)
        this.lastItem = null
        this.copyItem = null
        this.redoList = []//重做
        this.undoList = []//撤销
        let data = this.graph.save()
        let nodes = data.nodes
        let edges = data.edges
        if (nodes.length > 0) {
          nodes.forEach(node=>{
            node.id += ''//字符化
            if (node.id.indexOf("customNode") < 0) {
              this.deleteNodes.push(node.id+'')
            }
          })
        }
        if (edges.length > 0) {
          edges.forEach(edge=>{
            if (edge.tempId) {
              this.deleteEdges.push(edge.tempId+'')
            }
          })
        }
        this.graph.clear()
      },
      deleteItem(item) {
        let self = this
        let graph = this.graph
        const list = []
        const deleteEdges = []
        if (item) {
          if (!item.isItem() || item.destroyed) {
            //不是节点直接返回
            return;
          }
          const autoPaint = graph.get('autoPaint')
          graph.setAutoPaint(false)
          //判断item是节点还是边
          let type = item.getType()
          let model = item
          if (type === 'node') {
            //节点,删除节点和边
            let edges = item.getEdges()
            model = item.getModel()
            model.type = item.getType()
            model.id = item.get('id')
            let deleteId = model.id + ''
            if (deleteId.indexOf('customNode') < 0) {
              self.deleteNodes.push(deleteId)
            }
            let node = this.nodes.find(node=>{
              return node.id === deleteId
            })
            let index = this.nodes.indexOf(node)
            if (index > -1) {
              this.nodes.splice(index,1)
            }
            edges.forEach(edge => {
              //判断边是否hover,click
              //防止悬浮在边上，删除造成节点是悬浮的状态
              let hover = edge.hasState('hover')
              if (hover) {
                graph.setItemState(edge, 'hover', false)
              }
              //判断边是否有记录的
              //记录删除的边
              let edgeModel = edge.getModel()
              //edgeModel.type = 'edge'
              edgeModel.id = edge.get('id')
              list.push(edgeModel);
              //真正的ID
              //记录删除的线
              let tempId = edgeModel.tempId
              if (tempId) {
                self.deleteEdges.push(tempId+'')
              }
              //graph.removeItem(edge);
              //添加进的线（出的线，会跟节点一起删除）

              deleteEdges.push(edgeModel)
            });
            //graph.removeItem(item)
            //存储到删除的集合，需要重做的集合
            self.nodeDrawer = false

          } else if (type === 'edge') {
            //边，删除边
            //存储到删除的集合，需要重做的集合
            model = item.getModel()
            model.type = item.getType()
            model.id = item.get('id')
            const targetNode = item.getTarget()
            const sourceNode = item.getSource()
            graph.setItemState(targetNode, 'hover', false)
            graph.setItemState(sourceNode, 'hover', false)
            // graph.removeItem(item)
            let tempId = model.tempId
            if (tempId) {
              self.deleteEdges.push(tempId+'')
            }
            deleteEdges.push(model)
          }
          if (deleteEdges.length > 0) {
            deleteEdges.forEach(edge=>{
              self.handleDeleteData(edge)
            })
          }
          //end
          list.push(model);
          let key = 'delete'
          this.undoList.push({key, data: list})
          //删除
          graph.remove(item)
          self.redoList = []
          //self.selectItem = null
          graph.setAutoPaint(autoPaint)
          graph.paint()
        }
      },
      handleDeleteData(edge) {
        let sourceNode = this.graph.findById(edge.sourceId)
        let sourceModel = sourceNode.getModel()
        let data = null
        if (sourceModel.nodeData) {
          data = sourceModel.nodeData;
        }
        if (data) {
          let index = -1
          if (data.recognizes) {
            for (let i = 0; i < data.recognizes.length; i++) {
              let rec = data.recognizes[i]
              if (rec.edgeId) {
                if (rec.edgeId === edge.id) {
                  index = i
                  break
                }
              } else {
                if (edge.sourceId === rec.rsId && edge.targetId === rec.nextSceneId) {
                  index = i
                  break
                }
              }
            }
            if (index>-1) {
              let recognize = data.recognizes[index]
              data.recognizes.splice(index,1);
              if (recognize.id) {
                data.deleteRecognizes.push(recognize.id+'')
              }

              if (this.nodeDrawer) {
                if (this.nodeModel.id === edge.sourceId) {
                  eventBus.$emit('deleteRecognize',recognize);
                }
              }
            }

          }
          if (data.judges) {
            for (let i = 0; i < data.judges.length; i++) {
              let judge = data.judges[i]
              if (judge.edgeId) {
                if (judge.edgeId === edge.id) {
                  index = i
                  break
                }
              } else {
                if (edge.sourceId === judge.rsId && edge.targetId === judge.nextSceneId) {
                  index = i
                  break
                }
              }
            }
            if (index>-1) {
              let judge = data.judges[index]
              if (judge.id){
                data.deleteOrs.push(judge.id+'')
              }
              data.judges.splice(index,1)
              if (this.nodeDrawer) {
                if (this.nodeModel.id === edge.sourceId) {
                  eventBus.$emit('deleteJudge',judge);
                }
              }
            }
          }
          let model = {
            nodeData:data
          }
          this.graph.update(sourceNode,model)
        }
      },
      handleCopy() {
        let self = this
        if (self.selectItem) {
          if (self.selectItem.isItem()) {
            let type = self.selectItem.getType()
            if (type === 'edge') {
              return
            }
            self.copyItem = self.selectItem
          }
        }
      },
      handlePaste() {
        if (this.copyItem) {
          let model = this.copyItem.getModel()
          switch (model.color) {
            case '#000':
              model.label = '开始节点'
              model.name = '开始节点'
              break
            case '#00BFFF':
              model.label = '语音节点'
              model.name = '语音节点'
              break
            case '#FF6A6A':
              model.label = 'DTMF节点'
              model.name = 'DTMF节点'
              break
            case '#8B8682':
              model.label = 'HTTP节点'
              model.name = 'HTTP节点'
              break
            case '#8DB6CD':
              model.label = '结束节点'
              model.name = '结束节点'
              break
          }
          model.id = model.type + uniqueId()
          model.x = 100
          model.y = 100
          model.offsetX = 0
          model.offsetY = 0
          //this.addNodeOrEdge('node',model)
        }
      },
      handleRedo() {
        if (this.redoList.length <= 0) {
          return
        }
        const redoData = this.redoList.pop();
        const list = []
        const edgeList = []
        for (let i = 0; i < redoData.data.length; i++) {
          const data = redoData.data[i]
          if (data.type === 'customEdge') {
            edgeList.push(data)
            continue
          }
          list.push(data)
          this.doredo(redoData.key, data)
        }
        for (let i = 0; i < edgeList.length; i++) {
          const edge = edgeList[i]
          if (edge.source.destroyed) {
            edge.source = edge.sourceId
          }
          if (edge.target.destroyed) {
            edge.target = edge.targetId
          }
          list.push(edge)
          this.doredo(redoData.key, edge)
        }
        this.undoList.push({key: redoData.key, data: list})
      },
      doredo(key, data) {
        switch (key) {
          case 'add':
            this.add(data)
            break
          case 'update':
            break
          case 'delete':
            this.remove(data)
            break
        }
      },
      handleUndo() {
        if (this.undoList.length <= 0) {
          return
        }
        const undoData = this.undoList.pop();
        const edgeList = [];
        const list = []
        for (let i = 0; i < undoData.data.length; i++) {
          const data = undoData.data[i]
          if (data.type === 'customEdge') {
            edgeList.push(data)
            continue
          }
          list.push(data)
          this.doundo(undoData.key, data)
        }
        for (let i = 0; i < edgeList.length; i++) {
          const edge = edgeList[i]
          if (edge.source.destroyed) {
            edge.source = edge.sourceId
          }
          if (edge.target.destroyed) {
            edge.target = edge.targetId
          }
          list.push(edge)
          this.doundo(undoData.key, edge)
        }
        this.redoList.push({key: undoData.key, data: list})
      },
      doundo(key, data) {
        switch (key) {
          case 'add':
            this.remove(data)
            break
          case 'update':
            break
          case 'delete':
            this.add(data)
            break
        }
      },
      remove(data) {
        const item = this.graph.findById(data.id)
        this.deleteItem(item)
      },
      add(data) {
        let type = data.type
        if (type === 'customNode') {
          this.addNodeOrEdge('node', data, false)
        } else if (type === 'customEdge') {
          this.addNodeOrEdge('edge', data, false)
        }
      },
      initG6() {
        let self = this
        self.Util = G6.Util
        self.grid = new G6.Grid()
        self.miniMap = new G6.Minimap({
          container: self.navId,
          size: [150, 200],
          className: 'minimap',
          type: 'delegate'
        })
        self.graph = new G6.Graph({
          container: self.containerId,
          modes: {
            default: [
              'drag-canvas',
              {
                type: 'zoom-canvas',
                minZoom: 0.5,
                maxZoom: 10
              },
              {
                type: 'drag-node',
                enableDelegate: true
              },
              {
                type: 'click-select',
                trigger: 'ctrl'
              },
              {
                type: 'brush-select',
                trigger: 'shift'
              },
            ],
            addEdge: ['add-edge'],
          },
          height: self.drawerStyle.height,
          width: self.drawerStyle.width,
          minZoom: 0.5,
          maxZoom: 10,
          plugins: [self.miniMap,self.grid]
        })
        self.graph.data(this.data)
        self.graph.render()
      },
      initBind() {
        let graph = this.graph
        let self = this
        if (graph) {
          /*节点 鼠标进入事件*/
          graph.on('node:mouseover', e => {
            const item = e.item;
            const graph = self.graph;
            const group = item.getContainer()
            if (e.target.attrs.isOutPointOut || e.target.attrs.isOutPoint) {
              group.find(g => {
                if (g.attrs.isInPoint || g.attrs.isOutPoint) {
                  g.attr("fill", "#fff")
                }
                if (g.attrs.isOutPoint) {
                  if (g.attrs.id === e.target.attrs.parent) {
                    group.find(gr => {
                      if (gr.attrs.id === g.attrs.id) {
                        gr.attr('fill', "#1890ff")
                        gr.attr('opacity', 1)
                      }
                    })
                  }
                  if (g.attrs.id === e.target.attrs.id) {
                    g.attr("fill", "#1890ff")
                    g.attr('opacity', 1)
                  }

                }
              });
              e.target.attr("cursor", "crosshair");
              this.graph.paint();
            }
            if (item.hasState('selected')) {
              return
            } else {
              graph.setItemState(item, 'hover', true);
            }
            graph.paint();
          });
          /*节点 鼠标离开事件*/
          graph.on('node:mouseleave', e => {
            const item = e.item;
            const graph = self.graph;
            const group = item.getContainer()
            group.find(g => {
              if (g.attrs.isInPoint || g.attrs.isOutPoint) {
                g.attr("fill", "#fff")
              }
            });
            if (!item.hasState('selected')) {
              graph.setItemState(item, 'hover', false)
            }
            graph.paint();

          });
          /*节点 鼠标点击事件*/
          graph.on('node:click', ev => {
            //self.nodeDrawer = false
            const autoPaint = graph.get('autoPaint')
            graph.setAutoPaint(false)
            const clickNodes = graph.findAllByState('node', 'selected')
            clickNodes.forEach(node => {
              graph.setItemState(node, 'selected', false)
            })
            const clickEdges = graph.findAllByState('edge', 'selected')
            clickEdges.forEach(edge => {
              graph.setItemState(edge, 'selected', false)
            })

            const nodeItem = ev.item
            graph.setItemState(nodeItem, 'selected', true)
            graph.paint()
            graph.setAutoPaint(autoPaint)


            let model = nodeItem.getModel()
            self.lastItem = self.selectItem//记录上一次的数据
            self.nodeModel = model
            self.currentNode = nodeItem;
            self.selectItem = nodeItem
            //self.nodeDrawer = true
            /*setTimeout(()=>{

              self.nodeDrawer = true
            },1000)*/
            if (self.nodeDrawer) {
              self.nodeDrawer = false
              setTimeout(() => {
                self.nodeDrawer = true
              }, 500)
            } else {
              self.nodeDrawer = true
            }
          })
          /*节点 鼠标落下事件*/
          graph.on('node:mousedown',e => {
            if (e.target.attrs.isOutPoint || e.target.attrs.isOutPointOut) {
              self.graph.setMode('addEdge')
              //补偿当节点数据没有加载就连线会失败的问题
              const nodeItem = e.item
              const nodeModel = nodeItem.getModel()
              /*if (!nodeModel.nodeData) {
                let reg = /^[0-9]+.?[0-9]*$/;
                if (reg.test(nodeModel.id)) {
                  let data = await self.initNodeData(nodeModel.id, '');
                  let model = {
                    nodeData:data
                  }
                  self.graph.update(nodeItem,model)
                }
              }*/
            } else {
              self.graph.setMode('default')
            }
          })
          graph.on('node:mouseup', e => {
            self.graph.setMode('default')
          })
          /*边 点击事件*/
          graph.on('edge:click', ev => {
            const autoPaint = graph.get('autoPaint')
            graph.setAutoPaint(false)
            const clickEdges = graph.findAllByState('edge', 'selected')
            clickEdges.forEach(edge => {
              graph.setItemState(edge, 'selected', false)
            })
            const clickNodes = graph.findAllByState('node', 'selected')
            clickNodes.forEach(node => {
              graph.setItemState(node, 'selected', false)
            })
            const edgeItem = ev.item
            graph.setItemState(edgeItem, 'selected', true)
            graph.setAutoPaint(autoPaint)
            graph.paint()
            self.selectItem = edgeItem
          })
          /*边 鼠标进入事件*/
          graph.on('edge:mouseover', ev => {
            try {
              const edgeItem = ev.item
              graph.setItemState(edgeItem, 'hover', true)
              const targetNode = edgeItem.getTarget()
              const sourceNode = edgeItem.getSource()
              graph.setItemState(targetNode, 'hover', true)
              graph.setItemState(sourceNode, 'hover', true)
            }catch (e) {
              console.log(e)
            }

          });
          /*边 鼠标离开事件*/
          graph.on('edge:mouseleave', ev => {
            try {
              const edgeItem = ev.item
              if (!edgeItem.hasState('selected')) {
                graph.setItemState(edgeItem, 'hover', false);
              }
              const targetNode = edgeItem.getTarget()
              const sourceNode = edgeItem.getSource()
              graph.setItemState(targetNode, 'hover', false)
              graph.setItemState(sourceNode, 'hover', false)
            }catch (e) {
              console.log(e)
            }
          });
          /*画布点击事件*/
          graph.on('canvas:click', ev => {
            const autoPaint = graph.get('autoPaint')
            graph.setAutoPaint(false)
            //取消所有的节点选中
            const nodeItems = graph.findAllByState('node', 'selected')
            nodeItems.forEach(node => {
              graph.setItemState(node, 'selected', false)
            })
            //取消所有的边选中
            const edgeItems = graph.findAllByState('edge', 'selected')
            edgeItems.forEach(edge => {
              graph.setItemState(edge, 'selected', false)
            })
            graph.setAutoPaint(autoPaint)
            graph.paint()
            //关闭抽屉
            self.nodeDrawer = false
            //self.selectItem = null
          })
          /*画布上鼠标抬起事件*/
          graph.on('canvas:mouseup', ev => {
            const model = graph.getCurrentMode()
            if (model === 'addEdge') {
              graph.setMode('default')
            }
          })
          graph.on('canvas:mouseenter',e=>{
            self.graph.on('keydown',e=>{
              const keyCode = e.keyCode || e.which
              //删除事件 8 backspace 46 delete
              if (keyCode === 8 || keyCode === 46) {
                self.handleDelete()
              }
            })
          })
          graph.on('canvas:mouseleave',e=>{
            self.graph.off('keydown')
          })
          //绑定添加事件，对添加得数据进行更新
          graph.on('afteradditem',e=>{
            let type = e.model.type;
            if (self.deleteNodes.length > 0 || self.deleteEdges.length >0) {
              //如果是重做，添加需要删除已删除的节点数据

              if (type === 'customNode') {
                let nodeId = e.model.id + ''
                if (self.deleteNodes.length > 0) {
                  let index = self.deleteNodes.indexOf(nodeId)
                  if (index > -1) {
                    self.deleteNodes.splice(index,1)
                  }
                }
              }else if (type === 'customEdge') {
                let tempId = e.model.tempId
                if (tempId) {
                  let index = self.deleteEdges.indexOf(tempId)
                  if (index > -1) {
                    self.deleteEdges.splice(index,1)
                  }
                }
              }
            }
          })
        }
      },
      bindEvents() {
        let that = this
        eventBus.$on('addItem', item => {
          that.addNodeOrEdge('edge', item, true)
        })

        eventBus.$on('editFlow', item => {
          that.flowName = item.rwName
          that.flowId = item.id
          that.resetData()
          that.initData(item.id)
          that.initNodesData(item.id)
          //直接加载每一个数据
        })
        eventBus.$on('saveFlow',save=>{
          that.nodeDrawer = false
          if (save) {
            that.saveFlow()
          }
        })
      },
      mountDrawerArea(reduceHeight, reduceWidth) {
        let clientHeight = document.documentElement.clientHeight
        let clientWidth = document.documentElement.clientWidth
        this.drawerStyle.height = clientHeight - reduceHeight
        this.drawerStyle.width = clientWidth - reduceWidth
      }
    },
    destroyed() {
      eventBus.$off('editFlow')
      eventBus.$off('addItem')
      eventBus.$off('saveFlow')
    },
    mounted() {
      this.$nextTick(() => {
        this.initG6()
        this.initBind()
        initBehaviors()
        this.bindEvents()
      })
    },
    watch:{
      undoList:{
        deep:true,
        immediate:true,
        handler(value) {
          if (value.length <= 0) {
            this.undoClass.color = 'gray'
          } else {
            this.undoClass.color = '#2d8cf0'
          }
        }
      },
      redoList:{
        deep:true,
        immediate:true,
        handler(value) {
          if (value.length <= 0) {
            this.redoClass.color = 'gray'
          } else {
            this.redoClass.color = '#2d8cf0'
          }
        }
      }
    },
    created() {
      this.screenHeight.height = this.mountHeight(91)
      this.mountDrawerArea(40, 0)
    }
  };
</script>

<style scoped lang="css">
.el-header,.el-footer {
  background-color: #B3C0D1;
  color: #333;
  /*text-align: center;*/
  line-height: 40px;
  height: 40px!important;
  min-height: 40px!important;
  max-height: 40px!important;
}
  .el-aside{
    background-color: #D3DCE6;
    color: #333;
    text-align: center;
    line-height: 70px;
  }
  .el-main{
    background-color: #E9EEF3;
    color: #333;
    text-align: center;
    line-height: 160px;
    padding: 0;
  }
  .flow-title{
    overflow: hidden;
    text-align: center;
    display: inline-block;
    width: 150px;
    white-space: nowrap;
    text-overflow: ellipsis;

    float: left;
    font-size: 20px;
    font-weight: bold;
  }
  li i{
    cursor: pointer;
    font-size: 23px;
  }
  .header li {
    float: left;
    margin-left: 12px;
  }
  .header li i {
    font-size: 16px;
    color: #2d8cf0;
    cursor: pointer;
  }
  .header{
    list-style: none;
    margin-left: 60px;
  }
  .popperClass{
    height: auto;
    width: auto;
    border-radius: 1px;
  }
  a {
    color: #2d8cf0;
  }
  .win{
    position: absolute;
    bottom: 20px;
    right: 10px;
    height: 200px;
    width: 150px;
    color: gray;
    border: 1px solid #8d8f93;
  }
  .nodeClass{
    color: rgba(0,0,0,0.65);
    border-radius: 4px;
    width: 100px;
    min-width: 100px;
    height: 30px;
    line-height: 30px;
    border: 1px solid rgba(0,0,0,0);
    list-style-type: none;
  }
  .nodeClass :hover{
    background: white;
    border: 1px solid #ced4d9;
    cursor: move;
  }
  .left-icon{
    width: 28px;
    height: 28px;
    cursor: pointer;
  }
  .top-icon{
    width: 18px;
    height: 18px;
  }
  .nodeDiv{
    padding-top: 7px;
    display: flex;
  }
</style>



// WEBPACK FOOTER //
// src/components/flow/workspace.vue